import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Button,
  TextField,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./CallDialogs.css";

const renderField = (field, value, values, onChange) => {
  if (field.showWhen && !field.showWhen(values)) {
    return null;
  }

  if (field.type === "select") {
    return (
      <TextField
        key={field.name}
        select
        fullWidth
        size="small"
        label={field.label}
        value={value ?? ""}
        onChange={(event) => onChange(field.name, event.target.value)}
      >
        {field.options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    );
  }

  return (
    <TextField
      key={field.name}
      fullWidth
      size="small"
      type={field.type || "text"}
      label={field.label}
      placeholder={field.placeholder}
      value={value ?? ""}
      onChange={(event) => onChange(field.name, event.target.value)}
      InputLabelProps={field.type === "date" ? { shrink: true } : undefined}
    />
  );
};

export const CallFilterDialog = ({
  open,
  title,
  description,
  sections = [],
  values = {},
  onChange,
  onClose,
  onApply,
  onReset,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        className: "call-filter-dialog__paper",
      }}
    >
      <DialogTitle className="call-filter-dialog__title">
        <div className="call-filter-dialog__heading">
          <span>{title}</span>
          {description ? <small>{description}</small> : null}
        </div>
        <IconButton
          aria-label="Close filter dialog"
          onClick={onClose}
          className="call-filter-dialog__close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent className="call-filter-dialog__content">
        <div className="call-filter-dialog__grid">
          {sections.map((section) => (
            <div key={section.title} className="call-filter-dialog__section">
              <div className="call-filter-dialog__section-title">
                {section.title}
              </div>
              <div className="call-filter-dialog__fields">
                {section.fields.map((field) =>
                  renderField(field, values[field.name], values, onChange),
                )}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>

      <DialogActions className="call-filter-dialog__actions">
        <Button
          type="button"
          onClick={onReset}
          className="call-filter-dialog__button call-filter-dialog__button--secondary"
        >
          Reset
        </Button>
        <Button
          type="button"
          onClick={onApply}
          variant="contained"
          className="call-filter-dialog__button call-filter-dialog__button--primary"
        >
          Apply Filters
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CallFilterDialog;
